/// this is the basic module of WAMP in javascript
/// support by VRMaker<www.vrmaker.com.cn>


var _socket = null;

var _openCallbacks = [];

var _closeCallbacks = [];
var timer = null;

function reconnected(_wamp_socket, __socket_opened, __socket_closed, __socket_received) {
    // console.log('call reconnect')
    WampStart(_wamp_socket, __socket_opened, __socket_closed, __socket_received)
}

// start the connection to wamp server in the first time when this module is used
// if the socket not connected, start connection
var WampStart = function (_wamp_socket, __socket_opened, __socket_closed, __socket_received) {
    if (_socket != null) {
        return;
    }
    var wsImpl = WebSocket;
    var uri = 'ws://' + _wamp_socket.host + ':' + _wamp_socket.port + "/client";
    //console.log(uri)
    var ws = new wsImpl(uri);

    _socket = ws;
    ws.onmessage = (evt) => {
        if (__socket_received) {
            __socket_received(evt);
        }

    }

    ws.onopen = (ws) => {
        clearInterval(timer);
        timer = null;
        // console.log('socket connected!')
        if (__socket_opened) {
            __socket_opened(ws);
        }
        for (var i in _openCallbacks) {
            _openCallbacks[i]();
        }
    }
    ws.onclose = () => {
        _socket = null;
        // console.log('log socket disconnected!')
        if (__socket_closed) {
            __socket_closed();
        }
        for (var i in _closeCallbacks) {
            _closeCallbacks[i].callbacks();
        }

        reconnected(_wamp_socket, __socket_opened, __socket_closed, __socket_received)
    }
};

var WampSocket = {
    addSocketOpenEvent: function (event) {
        _openCallbacks.push(event);
    },
    removeSocketOpenEvent: function (event) {
        for (var i in _openCallbacks) {
            if (_openCallbacks[i] == event) {
                _openCallbacks.slice(i, 1);
            }
        }
    },
    addSocketCloseEvent: function (event) {
        _closeCallbacks.push(event)
    },
    removeSocketCloseEvent: function (event) {
        for (var i in _closeCallbacks) {
            if (_closeCallbacks[i] == event) {
                _closeCallbacks.slice(i, 1);
            }
        }
    },
    startConnect: function (_wamp_socket, __socket_opened, __socket_closed, __socket_received) {
        WampStart(_wamp_socket, __socket_opened, __socket_closed, __socket_received);
    }
}

module.exports = WampSocket;